import { NamesOfFieldEnum, ConfigNamesFields, NamesOfFieldBankInfoEnum } from "~/typings/types";

export const configTitleFieldsOfIndividualEntrepreneur: ConfigNamesFields = {
  [NamesOfFieldEnum.OrgType]: "ИП",
  [NamesOfFieldEnum.Name]: "ФИО",
  [NamesOfFieldEnum.Inn]: "ИНН",
  [NamesOfFieldEnum.Ogrn]: "ОГРН",
  [NamesOfFieldEnum.Ogrnip]: "ОГРНИП",
  [NamesOfFieldEnum.Kpp]: "КПП",
  [NamesOfFieldEnum.BankName]: "Название банка",
  [NamesOfFieldEnum.SettlementAccount]: "Расчётный счёт",
  [NamesOfFieldEnum.CorrespondentAccount]: "Корреспондентский счёт",
  [NamesOfFieldEnum.BankBic]: "БИК",
  [NamesOfFieldEnum.LegalAddress]: "Адрес регистрации (как в паспорте)",
  [NamesOfFieldEnum.PostalAddress]: "Почтовый адрес",
  [NamesOfFieldEnum.Vat]: "Являетесь ли плательщиком НДС?",
  [NamesOfFieldEnum.VatMode]: "Тип налогообложения",
  [NamesOfFieldEnum.SignatureInfo]: "Должность и ФИО лица, подписывающего договор",
  [NamesOfFieldEnum.LprName]: "ФИО ген. директора",
  [NamesOfFieldEnum.LprPhone]: "Мобильный телефон",
  [NamesOfFieldEnum.BuhName]: "ФИО бухгалтера",
  [NamesOfFieldEnum.BuhPhone]: "Мобильный телефон",
  [NamesOfFieldEnum.TechName]: "ФИО тех.специалиста",
  [NamesOfFieldEnum.TechPhone]: "Мобильный телефон",
  [NamesOfFieldEnum.PayformPhone]: "Номер телефона для обращения покупателей",
  [NamesOfFieldEnum.PayformEmail]: "Email для обращения покупателей",
  [NamesOfFieldEnum.PayformLinks]:
    "Ссылки на все ваши сайты и соцсети с информацией о предоставляемых услугах",
  [NamesOfFieldEnum.CrmName]: "ФИО",
  [NamesOfFieldEnum.CrmPhone]: "Мобильный телефон",
  [NamesOfFieldEnum.CrmEmail]: "E-mail",
  [NamesOfFieldEnum.CrmBirthday]: "Дата рождения",
  [NamesOfFieldEnum.CrmSocialLinks]: "Ссылка на профиль в соцсетях",
  [NamesOfFieldEnum.PaymentNotificationEmail]: "E-mail для уведомлений об оплате",
  [NamesOfFieldEnum.ProductType]: "Что будете продавать?",
  [NamesOfFieldEnum.ProductName]: "Название канала продаж/проекта",
  [NamesOfFieldEnum.PayformName]: "Ссылка на платёжную страницу, по которой к вам будут приходить покупатели",
  [NamesOfFieldEnum.EducationalMaterialsPlatform]:
    "На какой платформе размещены учебные материалы и информация о ваших услугах?",
  [NamesOfFieldEnum.PayformPaymentMethods]:
    "Какие методы оплат вы хотите сделать доступными для покупателей?",
  [NamesOfFieldEnum.ClientIntegrationInfo]:
    "Перечислите сервисы и платформы с которыми потребуются интеграции для осуществления продаж",
  [NamesOfFieldEnum.ShopName]: "Название вашего магазина",
  [NamesOfFieldEnum.ProductDescription]: "Описание вашей деятельности",
  [NamesOfFieldEnum.LogoFileId]: "Ваш логотип",
  [NamesOfFieldEnum.LogoMainFileId]: "Ваш логотип",
  [NamesOfFieldEnum.PassportFileId]: "Загрузите паспорт",
  [NamesOfFieldEnum.ClientFrom]: "Откуда вы о нас узнали?",
  [NamesOfFieldEnum.ClientPromocode]: "Промокод партнера",
  [NamesOfFieldEnum.ClientLengthOfService]: "Давно ли вы на рынке онлайн-образования?",
  [NamesOfFieldEnum.IsHaveEducationalLicense]: "Есть ли у вас образовательная лицензия?",
  [NamesOfFieldEnum.PaymentMethodProdamusSubscription]: "Каким способом вам удобней оплатить подключение к Продамус?",
  [NamesOfFieldEnum.DocumentAgreement1FileId]: "Загрузите договор оказания услуг или оферту",
  [NamesOfFieldEnum.DocumentAgreement1NewFileId]: "Если вы оказываете услуги совместно с третьими лицами (с привлечением третьих лиц), загрузите договор оказания услуг",
  [NamesOfFieldEnum.Offer]: "Загрузите оферту",
  [NamesOfFieldEnum.DocumentPricesTariffsFileId]: "Прайсы/Тарифы на ваши услуги",
  [NamesOfFieldEnum.IsNeedOnlineKassa]: "Есть ли у вас своя онлайн-касса?",
};

export const configTitleFieldsOfBank = {
  [NamesOfFieldBankInfoEnum.BankName]: "Название банка",
  [NamesOfFieldBankInfoEnum.BankInn]: "ИНН банка",
  [NamesOfFieldBankInfoEnum.BankBic]: "БИК банка",
  [NamesOfFieldBankInfoEnum.BankKpp]: "КПП банка",
  [NamesOfFieldBankInfoEnum.BankCorrespondentAccount]: "Корреспондентский счёт банка"
};
